import { Component, OnInit } from '@angular/core';
import { Category } from '../category';
import { ActivatedRoute } from '@angular/router';
import { CategoryService } from '../category.service';
import { Message } from 'primeng/primeng';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Validators,FormControl,FormGroup,FormBuilder } from '@angular/forms';


@Component({
  selector: 'app-category-crud',
  templateUrl: './category-crud.component.html',
  styleUrls: ['./category-crud.component.css'],
   providers: [CategoryService]
})
export class CategoryCrudComponent implements OnInit {

  id: null;
	category: Category;
  categoryFetch: any = [];
  categoryForm: FormGroup;
  selectedParentCategory: string;
  loading: boolean = false;
  msgs: Message[] = [];
  button_caption: string ="Сохранить"
  button_icon:string ="fa fa-save";

  constructor(
    private categoryService: CategoryService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private location: Location
    ) { 

      activatedRoute.params.subscribe(params=>{this.id=params['id']});

      this.categoryForm = this.fb.group({
            'parent_id': new FormControl(),
            'name': new FormControl('', Validators.required),
            'description': new FormControl(),
            // 'icon': new FormControl(),
            // 'position': new FormControl(),
            // 'level': new FormControl(),
            // 'left_margin': new FormControl(),
            // 'right_margin': new FormControl(),
            'available': new FormControl('', Validators.required)
      }); 





      if(this.id){
            this.loading = true;
            this.categoryService.getCategoryById(this.id).subscribe(response=>{

                this.categoryService.getCategory().subscribe(response=>{
                        this.recarray(response['data'],'children',this);
                        this.category.parents=this.categoryFetch.map(function(value: any){
                                                        return {label:value.name, value: value.id};
                                             });  
                });
                this.category = response['data'];
                this.selectedParentCategory = response['data'].parent_id;  
                this.loading=false;
            });

            this.button_caption="Редактировать";
            this.button_icon="fa fa-edit";
      }else{
               this.categoryService.getCategory().subscribe(response=>{
                      this.recarray(response['data'],'children',this);
                      this.category.parents=this.categoryFetch.map(function(value: any){
                                                        return {label:value.name, value: value.id};
                                             });  
               });
      }
  }

  ngOnInit() {

     this.category={
                parents: [],
                name: "",
                // description: "",
                // icon: "",
                // position: "",
                // level: "",
                // left_margin: "",
                // right_margin: "",
                available: false
        };
  }

  recarray(ar: any, searchfor: any,that: any) {
          ar.forEach(function(item: any,i: any,arr: any){
              if(item instanceof Object){
                  if("children" in item){
                     that.recarray(item['children'],searchfor,that)
                  }
                  that.categoryFetch.push(item);
              }
          });
  }


  backClicked() {
        this.location.back();
  }

  crud(form):void{
         if(!this.id){
             this.loading=true;   
             form.value['parent_id'] = form.value['parent_id'] || 0;
             this.categoryService.createCategory(form.value)
             .subscribe((data) => {this.loading=false; this.router.navigate(['/dashboard/category']);}
                  , (error)=>{this.loading=false;let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body));});

         }else{
             this.loading=true;   
             this.categoryService.updateCategory(form.value,this.id)
             .subscribe((data) => {this.loading=false; this.router.navigate(['/dashboard/category']);}
                  , (error)=>{this.loading=false;let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body));});
         }
  }
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/categories/category-crud/category-crud.component.ts